import React from "react";
import "./GMBScoring.css";

const LockOverview = ({ isIssue, issuesRemaning }) => {
  return (
    <div className="lock-overview-container">
      <button
        onClick={() => {
          window.open(
            "https://localranker.fr/demander-demo?utm_source=localranker.tech&utm_medium=audit-google-my-business",
            "_blank",
          );
        }}
        className="locked-btn"
      >
        Débloquez l'audit complet sur Localranker
      </button>
      {isIssue && issuesRemaning > 0 && (
        <p style={{ textAlign: "center", fontSize: 13, color: "var(--color-text-muted)", marginTop: 8 }}>
          {issuesRemaning} autre(s) problème(s) à régler
        </p>
      )}
    </div>
  );
};

export default LockOverview;
